import React from "react"
import {
    Container,
    Col,
    Row
  } from 'reactstrap';

function Intro(){
    return(
        <Container fluid className="fullscreen introblurb">
            <Row className="justify-content-center align-items-center">
                <Col lg="6" md="8" xs="10" className="text-left">
                <h3><strong>In 2019, more people will vote than ever before.</strong></h3>
                <br/>
                <p>Nearly <strong>two billion</strong> voters in 50 countries around the world will head to the polls this year to elect their leaders.</p>
                <p>Some of the biggest elections include <strong>India</strong> - the world’s largest democracy with 800 million eligible voters, <strong>Indonesia</strong> - 187 million registered voters and <strong>Nigeria</strong> - 84 million registered voters.</p>
                <p>Here’s how different voting systems work around the world:</p>
                </Col>
            </Row>
        </Container>
    )
}

export default Intro